import React, { Component } from 'react';
import PropTypes from 'prop-types';
import FAQList from './faq_list';
import FAQDetail from './faq_detail';

class FAQs extends Component {
  componentDidMount(){
  }
  render() {
    //console.log(this.context);
    var params = this.context.router.route.match.params;
    var view;
    if(params.action===undefined){
      view = <FAQList/>;
    }else{
      if(params.id===undefined){
        view = <FAQDetail/>;
      }else{
        view = <FAQDetail action={params.action}/>;
      }
    }
    return (
      <div className="page-wrapper">{view}</div>
    );
  }
}

FAQs.contextTypes = {
  router: PropTypes.object
};

export default FAQs;
